import { FC } from 'react';
import { AdminDiscountsList } from 'containers/admin';
import { AdminDiscountsLayout } from 'pages/atoms';

const AdminDiscountReportsPage: FC = () => {
  return (
    <AdminDiscountsLayout>
      <AdminDiscountsList />
    </AdminDiscountsLayout>
  );
};

export default AdminDiscountReportsPage;
